module.exports = __webpack_public_path__ + "static/showcase_arenafighttv-12faef3d14ec94f0b168258ede226eda.mp4";